import { Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React from "react";

import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const WebsiteLayout = () => {
  const { userId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  return (
    <Grid container direction="column" minHeight="100vh">
      {/* Header Section */}
      <Grid item>
        <Header />
      </Grid>

      {/* Main Content Section */}
      <Grid item sx={{ marginTop: 8, flexGrow: 1 }}>
        <Outlet />
      </Grid>

      {/* Footer Section based on role */}
      <Grid item>
        {role < 4 ? (
          <Grid container sx={{ display: { xs: "none", md: "block" } }}>
            <Footer />
          </Grid>
        ) : (
          <Grid container sx={{ bgcolor: "#010b1d", color: "#bdbdbd" }}>
            <Grid item xs={12}>
              <Typography textAlign="center" sx={{ margin: 2 }}>
                Copyright © {new Date().getFullYear()} - Optima Jobs. Designed &
                Developed by Pipasa Technology
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default WebsiteLayout;
